export default "__VITE_ASSET__f$clo6Kz__"